import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ChevronDown } from 'lucide-react';
import { isHomepageDemoLauncherEnabled } from '../../homepageDemoLauncherEnabled';
import './CustomerHeroSection.css';

function scrollTo(id) {
  var el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
}

const CustomerHeroSection = () => {
  const demoLauncherEnabled = isHomepageDemoLauncherEnabled();

  return (
    <section className="bh-hero" id="bot-hero" aria-label="B-esper Bot">

      <div className="bh-hero-inner">

        <div className="bh-hero-copy">
          <p className="bh-eyebrow">B-ESPER BOT</p>
          <h1 className="bh-h1">
            The European AI assistant
            <em> built for your business.</em>
          </h1>
          <p className="bh-tagline">
            Buy once, connect your website and knowledge sources, and launch a
            compliant assistant in minutes.
          </p>
          <div className="bh-quickpath" aria-label="Bot onboarding path">
            <span className="bh-quickpath-step">1. Buy</span>
            <span className="bh-quickpath-step">2. Connect site + files</span>
            <span className="bh-quickpath-step">3. Deploy live bot</span>
          </div>
          <div className="bh-cta-row">
            {demoLauncherEnabled ? (
              <button className="bh-cta bh-cta--primary" onClick={function(){ scrollTo('bot-demo'); }}>
                <span>Try the Bot</span><ArrowRight size={15} />
              </button>
            ) : (
              <Link className="bh-cta bh-cta--primary" to="/marketplace">
                <span>Get B-esper Bot</span><ArrowRight size={15} />
              </Link>
            )}
            <button className="bh-cta bh-cta--outline" onClick={function(){ scrollTo('bot-demo'); }}>
              <span>See how it works</span><ArrowRight size={15} />
            </button>
          </div>
          <p className="bh-sub-tagline">
            EU-hosted&nbsp;&nbsp;·&nbsp;&nbsp;GDPR compliant&nbsp;&nbsp;·&nbsp;&nbsp;self-maintaining&nbsp;&nbsp;·&nbsp;&nbsp;€25/month
          </p>
        </div>

        <div className="bh-hero-visual">
          <div className="bh-diagram-frame">
            <img
              src="/resources/images/hero-bot-diagram.jpg"
              alt="B-esper Bot diagram — website knowledge base and file library feed the bot; site and conversation analytics; deploy as a website widget or direct embed"
              className="bh-diagram-img"
              decoding="async"
            />
          </div>
        </div>

      </div>

      <button className="bh-scroll-foot" onClick={function(){ scrollTo('bot-demo'); }}>
        <span>Scroll to explore</span>
        <ChevronDown size={16} />
      </button>

    </section>
  );
};

export default CustomerHeroSection;
